var _g, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    clipPath: "url(#clip0_324_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.999 12.5254V19.4664C23.9991 20.0275 23.7652 20.5675 23.3452 20.9758C22.9252 21.3841 22.3509 21.6298 21.7398 21.6627L21.599 21.6664H10.399C9.78685 21.6664 9.19781 21.452 8.75241 21.067C8.30702 20.6821 8.03894 20.1556 8.00302 19.5955L7.99902 19.4664V12.5254L15.555 17.1432L15.6478 17.1916C15.7572 17.2406 15.8773 17.266 15.999 17.266C16.1207 17.266 16.2409 17.2406 16.3502 17.1916L16.443 17.1432L23.999 12.5254Z",
    fill: "#886CC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5995 9.93311C22.4635 9.93311 23.2211 10.3511 23.6435 10.9796L15.9995 15.6509L8.35547 10.9796C8.55605 10.6809 8.83164 10.4306 9.15923 10.2495C9.48683 10.0683 9.85693 9.9616 10.2387 9.93824L10.3995 9.93311H21.5995Z",
    fill: "#886CC0"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#886CC0",
    fillOpacity: 0.12
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_324_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 17.6,
    fill: "white",
    transform: "translate(6.40039 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.fa0dba3491774bba65da8b86e4aa4ed9.svg";
export { ForwardRef as ReactComponent };